<template>
  <div
    class="cursor-pointer h-full flex items-center no-underline text-primary"
    @click="downloadCSV"
  >
    <i class="fa fa-download mr-2" />
    <span class="uppercase">{{ buttonText }}</span>
  </div>
</template>

<script>
import DownloadStream from '../../../plugins/DownloadStream';
import makeRequest from '../../../utils/apiRequest';

export default {
  name: 'DownloadCSV',
  mixins: [DownloadStream],
  props: {
    downloadUrl: {
      type: String,
      default: null,
    },
    buttonText: {
      type: String,
      default: 'Download CSV',
    },
    fileName: {
      type: String,
      default: 'File',
    },
  },
  methods: {
    downloadCSV() {
      if (this.downloadUrl) {
        const downloadMeta = {
          url: this.downloadUrl,
        };

        makeRequest(downloadMeta)
          .then((response) => {
            if (response.data) {
              this.downloadStream(response.data, this.fileName, 'csv');
            }
            this.$ga.event({
              eventCategory: 'Downloads',
              eventAction: 'CSV',
              eventLabel: this.fileName,
            });
          })
          .catch((response) => {
            this.$notification.error('Error downloading file');
            console.error(response);
          });
      }
    },
  },
};
</script>
